export default from './Menu';



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/index.js